import EmailStep from "../components/auth/steps/EmailStep";

const LandingOfferPage = () => {

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-[#4f47e5]">
        <EmailStep onClose={() => {}} email={''} onNext={() => {}} offer={true} />
    </div>
  );
};

export default LandingOfferPage;